{
  "version": 1,
  "asset_id": "72dcc2ab-bffb-49ec-8585-4c8c140e9df7",
  "project_id": "e692c292-fbeb-41e1-8213-5a4529ec6f58",
  "url": "/__l5e/assets-v1/72dcc2ab-bffb-49ec-8585-4c8c140e9df7/cert-1.png",
  "r2_key": "a/v1/e692c292-fbeb-41e1-8213-5a4529ec6f58/72dcc2ab-bffb-49ec-8585-4c8c140e9df7/cert-1.png",
  "original_filename": "cert-1.png",
  "size": 50831,
  "content_type": "image/png",
  "created_at": "2026-07-13T04:09:53Z"
}
